import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
  Tooltip as ChartTooltip,
  ResponsiveContainer,
} from 'recharts';
import type { ChartTheme, TimelineDatum } from '../types';
import { DASHBOARD_LABELS as LABELS } from '../../../utils/labels';

interface TimelineChartProps {
  data: TimelineDatum[];
  chartTheme: ChartTheme;
  isDark: boolean;
}

export default function TimelineChart({ data, chartTheme, isDark }: TimelineChartProps) {
  const { chartTextColor, gridColor, tooltipStyle } = chartTheme;

  return (
    <ResponsiveContainer width="100%" height={220}>
      <LineChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={gridColor} vertical={false} />
        <XAxis
          dataKey="date"
          tick={{ fill: chartTextColor, fontSize: 11 }}
          axisLine={false}
          tickLine={false}
          interval={1}
        />
        <YAxis
          tick={{ fill: chartTextColor, fontSize: 11 }}
          axisLine={false}
          tickLine={false}
          allowDecimals={false}
          width={28}
        />
        <ChartTooltip contentStyle={tooltipStyle} />
        <Legend
          iconType="circle"
          iconSize={8}
          formatter={(value) => (
            <span style={{ color: chartTextColor, fontSize: '0.8125rem' }}>{value}</span>
          )}
        />
        <Line
          type="monotone"
          dataKey="aankomsten"
          name={LABELS.timelineArrivals}
          stroke={isDark ? '#a8b4ff' : '#2243d0'}
          strokeWidth={2}
          dot={{ r: 3, fill: isDark ? '#a8b4ff' : '#2243d0' }}
          activeDot={{ r: 5 }}
        />
        <Line
          type="monotone"
          dataKey="retours"
          name={LABELS.timelineReturns}
          stroke={isDark ? '#34d399' : '#059669'}
          strokeWidth={2}
          dot={{ r: 3, fill: isDark ? '#34d399' : '#059669' }}
          activeDot={{ r: 5 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
